import React from 'react';
import {useFirestoreConnect, useFirestore} from 'react-redux-firebase'
import {useSelector, useDispatch} from 'react-redux'
import {env} from '../../constants/Environment';
import {Table, Icon} from 'semantic-ui-react';
import {push} from '../../actions/RouterActions'
import {UsersNavigation} from './Navigation';

export default function(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    useFirestoreConnect([
        { collection: 'environments/' + env + '/users' }
    ])

    const users = useSelector(({firestore: {ordered}}) => {
        if(ordered['environments/' + env + '/users']){
            let lsort = _.clone(ordered['environments/' + env + '/users']);
            lsort.sort((a, b) => {
                if(a.id.localeCompare(b.id) !== 0)return a.id.localeCompare(b.id);
                return a.id.localeCompare(b.id);
            });
        
            return lsort;
        }else{
            return [];
        }
    });

    return (
        <UsersNavigation>
            <div style={{
                margin: '10px'
            }}>
                <h1><Icon name="users" /> Benutzerverwaltung</h1>
                {
                    (users)?
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={3}>
                                    ID
                                </Table.HeaderCell>
                                <Table.HeaderCell  width={3}>
                                    Name
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                    {
                        users.map((user) => (
                            (user.id.match('@'))?
                            <Table.Row>
                                <Table.Cell>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(push('/system/users/' + user.id));
                                    }}>{user.id}</a>
                                </Table.Cell>
                                <Table.Cell>
                                    {user.name}
                                </Table.Cell>
                            </Table.Row>
                            :null
                        ))
                    }
                        </Table.Body>
                    </Table>
                    :null
                }
            </div>
        </UsersNavigation>
    )
}